<template>
  <div id="app" class="w-full h-full">
    <Loader :loading="true" fullscreen target="body" lock/>
  </div>
</template>

<script>
import Loader from "@/components/ui/Loader.vue";

export default {
  name: 'LoaderView',
  components: {
    Loader
  }
}
</script>